// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3WS6q","header":"MessagesList_header__Q24cK","chat":"MessagesList_chat__15cnT"};